// extracted by mini-css-extract-plugin
export default {"Button":"a4nOaSMD","Small":"FLNWCwID"};